import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  changeHandler() {
    let tel = this.inputTarget.value
    console.log('[normalize-tel] input:', tel)

    if (tel.startsWith('+81')) {
      tel = '0' + tel.slice(3)
    } else if (!tel.startsWith('0') && /^\d{9,10}$/.test(tel)) {
      tel = '0' + tel
    }

    this.inputTarget.value = tel
  }
}
